export const convertFCFAToEUR = (amount: number): number => {
    const FCFA_TO_EUR_RATE = 1/500; // 1 EUR = 500 FCFA
    return Number((amount * FCFA_TO_EUR_RATE).toFixed(2));
};

export const convertEURToFCFA = (amount: number): number => {
    const EUR_TO_FCFA_RATE = 500; // 500 FCFA = 1 EUR
    return Math.round(amount * EUR_TO_FCFA_RATE);
};

// Taux de conversion entre XAF (FCFA) et les autres devises
const CURRENCY_RATES = {
    XAF: 1, // Franc CFA BEAC (Cameroun, Congo-Brazzaville, Gabon)
    XOF: 1, // Franc CFA BCEAO (Sénégal, Bénin) - 1 XAF = 1 XOF
    CDF: 5, // Franc Congolais (Congo-Kinshasa) - 1 XAF = 5 CDF
    LRD: 0.5, // Dollar Libérien (Liberia) - 2 XAF = 1 LRD
    UGX: 7, // Shilling Ougandais (Ouganda) - 1 XAF = 7 UGX
    GNF: 15, // Franc Guinéen (Guinée-Conakry) - 1 XAF = 15 GNF
};

// Symboles des devises pour l'affichage
export const CURRENCY_SYMBOLS = {
    XAF: 'FCFA',
    XOF: 'FCFA',
    CDF: 'FC',
    LRD: 'L$',
    UGX: 'USh',
    GNF: 'FG',
};

/**
 * Convertit un montant de XAF (FCFA) vers une autre devise
 * @param amount Montant en XAF
 * @param targetCurrency Devise cible
 * @returns Montant converti dans la devise cible
 */
export const convertXAFToCurrency = (amount: number, targetCurrency: keyof typeof CURRENCY_RATES): number => {
    if (!CURRENCY_RATES[targetCurrency]) {
        console.error(`Devise non prise en charge: ${targetCurrency}`);
        return amount; // Retourner le montant original en cas d'erreur
    }
    
    const rate = CURRENCY_RATES[targetCurrency];
    return Math.round(amount * rate);
};

/**
 * Convertit un montant d'une devise vers XAF (FCFA)
 * @param amount Montant dans la devise source
 * @param sourceCurrency Devise source
 * @returns Montant converti en XAF
 */
export const convertCurrencyToXAF = (amount: number, sourceCurrency: keyof typeof CURRENCY_RATES): number => {
    if (!CURRENCY_RATES[sourceCurrency]) {
        console.error(`Devise non prise en charge: ${sourceCurrency}`);
        return amount; // Retourner le montant original en cas d'erreur
    }
    
    const rate = CURRENCY_RATES[sourceCurrency];
    return Math.round(amount / rate);
};

/**
 * Formate un montant avec le symbole de la devise
 * @param amount Montant à formater
 * @param currency Code de la devise
 * @returns Montant formaté avec le symbole de la devise
 */
export const formatCurrency = (amount: number, currency: keyof typeof CURRENCY_SYMBOLS): string => {
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    return `${amount.toLocaleString('fr-FR')} ${symbol}`;
};
